module.exports = __webpack_public_path__ + "img/radio1.1d51c0a5.png";